var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.catalogo)?_c('v-chip',{staticClass:"ml-2",attrs:{"close":"","small":""},on:{"click:close":function($event){return _vm.onCloseCatalogo()}}},[_vm._v(" Catálogo: "+_vm._s(_vm.catalogo.nome)+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }